/**
 * enum for pages names
 * @type {String}
 */
export const PageName = {
  MAIN: `main`,
  FLATS: `flats`
};
/**
 * enum for common options configuration
 * @type {String}
 */
export const CommonOption = {
  MOBILE_VERSION_WIDTH: 960
};

export const mainScreenName = {
  INTRO: `intro`,
  ABOUT: `about`,
  EVENTS: `events`,
  PLACE: `place`,
  INFRASTRUCTURE: `infrastructure`,
  FLATS: `flats`,
  CONTACTS: `contacts`
};

/**
 * enum for screen names according to index
 * @type {String}
 */
export const ScreenName = {
  1: `intro`,
  2: `about`,
  3: `place`,
  4: `infrastructure`,
  5: `flats`,
  6: `events`,
  7: `contacts`
};
/**
 * enum for screen index according to name
 * @type {Number}
 */
export const ScreenIndex = {
  [`intro`]: 1,
  [`place`]: 2,
  [`infrastructure`]: 3,
  [`flats`]: 4,
  [`contacts`]: 5
};

export const snazzyMapStyle = [
  {
    "featureType": "all",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "saturation": 36
      },
      {
        "color": "#000000"
      },
      {
        "lightness": 40
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "visibility": "on"
      },
      {
        "color": "#000000"
      },
      {
        "lightness": 16
      }
    ]
  },
  {
    "featureType": "all",
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 20
      }
    ]
  },
  {
    "featureType": "administrative",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 17
      },
      {
        "weight": 1.2
      }
    ]
  },
  {
    "featureType": "landscape",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 20
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 21
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.fill",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 17
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry.stroke",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 29
      },
      {
        "weight": 0.2
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 18
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 16
      }
    ]
  },
  {
    "featureType": "transit",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 19
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#000000"
      },
      {
        "lightness": 17
      }
    ]
  }
];
/**
 * Enum for data sources
 * @type {string}
 */
export const DataSource = {
  FLATS_LIST: `/flats/flats_list/`
};
/**
 * Enum for range initial values
 * @type {array}
 */
export const RangeInitialValues = {
  floor: [0, 4],
  square: [0, 502.0],
  rooms: [0, 3],
  type: ``
};
